import { render } from "./Diapo.vue?vue&type=template&id=50932848&scoped=true"
import script from "./Diapo.vue?vue&type=script&lang=js"
export * from "./Diapo.vue?vue&type=script&lang=js"

import "./Diapo.vue?vue&type=style&index=0&id=50932848&lang=css"
import "./Diapo.vue?vue&type=style&index=1&id=50932848&scoped=true&lang=css"

import exportComponent from "D:\\Development\\VSTS.Git\\FleuristeBergeron\\Spec_2.0\\Solutions\\WWW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50932848"]])

export default __exports__